import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import {
    Play,
    X,
    Calendar,
    User,
    Eye,
    Heart,
    Share2,
    ChevronRight,
    Search,
    TrendingUp,
    Zap,
    AlertCircle
} from 'lucide-react';

function VideosNovedades() {
    
    const [selectedNoticia, setSelectedNoticia] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [filtroCategoria, setFiltroCategoria] = useState('todas');
    const [searchTerm, setSearchTerm] = useState('');
    const [favoritos, setFavoritos] = useState([]);

    // Datos de noticias y novedades
    const noticiasData = [
        {
            id: 1,
            titulo: "Motobomba para Agua",
            categoria: "producto",
            fecha: "2026-05-20",
            imagen: "/images/bombainflar.jpg",
            descripcion: "Motobomba autocebante 2x2, gasolina 7HP, agrícola, TRUPER",
            contenido: "",
            video: {
                titulo: "Demo: Taladro TRUPER 20V",
                archivo: '/videos/video1.mp4',
                duracion: "2:45"
            },
            caracteristicas: [
               
            ],
            destacado: false,
            tipo: "lanzamiento"
        },
        {
            id: 2,
            titulo: "Motobomba para Agua",
            categoria: "producto",
            fecha: "2026-05-20",
            imagen: "/images/img1.png",
            descripcion: "Motobomba autocebante 2x2, gasolina 7HP, agrícola, TRUPER",
            contenido: "",
            video: {
                titulo: "Demo: Taladro TRUPER 20V",
                archivo: '/videos/video2.mp4',
                duracion: "2:45"
            },
            caracteristicas: [
              
            ],
            destacado: false,
            tipo: "lanzamiento"
        },
         {
            id: 3,
            titulo: "Motobomba para Agua",
            categoria: "producto",
            fecha: "2026-05-20",
            imagen: "/images/img11.png",
            descripcion: "Motobomba autocebante 2x2, gasolina 7HP, agrícola, TRUPER",
            contenido: "",
            video: {
                titulo: "Demo: Taladro TRUPER 20V",
                archivo: '/videos/video3.mp4',
                duracion: "2:45"
            },
            caracteristicas: [
                
            ],
            destacado: false,
            tipo: "lanzamiento"
        },
        {
            id: 4,
            titulo: "Motobomba para Agua",
            categoria: "producto",
            fecha: "2026-05-20",
            imagen: "/images/bombainflar.jpg",
            descripcion: "Motobomba autocebante 2x2, gasolina 7HP, agrícola, TRUPER",
            contenido: "",
            video: {
                titulo: "Demo: Taladro TRUPER 20V",
                archivo: '/videos/video5.mp4',
                duracion: "2:45"
            },
            caracteristicas: [
               
            ],
            destacado: false,
            tipo: "lanzamiento"
        },
        {
            id: 5,
            titulo: "Showroom Salcedo Importaciones",
            categoria: "producto",
            fecha: "2026-05-20",
            imagen: "",
            descripcion: "Cada visita deja una historia, una experiencia y una nueva conexión.¡𝐁𝐢𝐞𝐧𝐯𝐞𝐧𝐢𝐝𝐨𝐬 𝐚 𝐂𝐨𝐧𝐞𝐱𝐢𝐨́𝐧𝐒𝐡𝐨𝐰𝐫𝐨𝐨𝐦!Ellos ya lo hicieron… ¡Mira lo que dijeron!",
            contenido: "",
            video: {
                titulo: "Demo: Taladro TRUPER 20V",
                archivo: '/videos/video7.mp4',
                duracion: "2:45"
            },
            caracteristicas: [
               "Cada visita deja una historia, una experiencia y una nueva conexión.¡𝐁𝐢𝐞𝐧𝐯𝐞𝐧𝐢𝐝𝐨𝐬 𝐚 𝐂𝐨𝐧𝐞𝐱𝐢𝐨́𝐧𝐒𝐡𝐨𝐰𝐫𝐨𝐨𝐦!Ellos ya lo hicieron… ¡Mira lo que dijeron!"
            ],
            destacado: true,
            tipo: "lanzamiento"
        },
        {
            id: 6,
            titulo: "Discos de Corte",
            categoria: "producto",
            fecha: "2026-05-20",
            imagen: "/images/img16.png",
            descripcion: "Motobomba autocebante 2x2, gasolina 7HP, agrícola, TRUPER",
            contenido: "",
            video: {
                titulo: "Demo: Taladro TRUPER 20V",
                archivo: '/videos/video8.mp4',
                duracion: "2:45"
            },
            caracteristicas: [
               
            ],
            destacado: false,
            tipo: "lanzamiento"
        },
        {
            id: 7,
            titulo: "Discos de Diamante",
            categoria: "producto",
            fecha: "2026-05-20",
            imagen: "/images/discosabrasivos.jpeg",
            descripcion: "Motobomba autocebante 2x2, gasolina 7HP, agrícola, TRUPER",
            contenido: "",
            video: {
                titulo: "Demo: Taladro TRUPER 20V",
                archivo: '/videos/video9.mp4',
                duracion: "2:45"
            },
            caracteristicas: [
               
            ],
            destacado: false,
            tipo: "lanzamiento"
        },
        {
            id: 8,
            titulo: "𝗡𝗶𝘃𝗲𝗹 𝗟𝗮́𝘀𝗲𝗿 𝗣𝗥𝗘𝗧𝗨𝗟 𝟯𝟲𝟬°",
            categoria: "producto",
            fecha: "2026-05-20",
            imagen: "/images/img15.png",
            descripcion: "Ideal para trabajos de alta precisión gracias a su autonivelación, líneas verdes de gran visibilidad y accesorios incluidos para mayor ",
            contenido: "",
            video: {
                titulo: "Demo: Taladro TRUPER 20V",
                archivo: '/videos/video10.mp4',
                duracion: "2:45"
            },
            caracteristicas: [
               "Láser verde 4X mayor visibilidad ",
               "Fácil nivelación",
               "Alta Precisión "
            ],
            destacado: true,
            tipo: "lanzamiento"
        },
        {
            id: 9,
            titulo: "Cintas Aislantes",
            categoria: "producto",
            fecha: "2026-05-20",
            imagen: "/images/cintas.jpg",
            descripcion: "",
            contenido: "",
            video: {
                titulo: "Demo: Taladro TRUPER 20V",
                archivo: '/videos/cintas.mp4',
                duracion: "2:45"
            },
            caracteristicas: [
               "Láser verde 4X mayor visibilidad ",
               "Fácil nivelación",
               "Alta Precisión "
            ],
            destacado: false,
            tipo: "lanzamiento"
        },
        
        
    ];

    const categorias = [
        { id: 'todas', nombre: 'Todos' },
        { id: 'producto', nombre: 'Productos' },
        { id: 'novedad', nombre: 'Novedad' },
        // { id: 'distribucion', nombre: 'Distribución' },
        // { id: 'tecnologia', nombre: 'Tecnología' }
    ];

    // Filtrar noticias
    const noticiasFiltradas = noticiasData.filter(noticia => {
        const coincideCategoria = filtroCategoria === 'todas' || noticia.categoria === filtroCategoria;
        const coincideBusqueda = noticia.titulo.toLowerCase().includes(searchTerm.toLowerCase()) || noticia.descripcion.toLowerCase().includes(searchTerm.toLowerCase());
        return coincideCategoria && coincideBusqueda;
    });

    // Ordenar por fecha (más recientes primero)
    const noticiasOrdenadas = [...noticiasFiltradas].sort((a, b) => 
        new Date(b.fecha) - new Date(a.fecha)
    );

    // Manejar click en noticia
    const handleNoticiaClick = (noticia) => {
        setSelectedNoticia(noticia);
        setShowModal(true);
    };

    // Agregar/remover favoritos
    const toggleFavorito = (id) => {
        setFavoritos(prev =>
            prev.includes(id)
                ? prev.filter(fav => fav !== id)
                : [...prev, id]
        );
    };

    // Formatear fecha
    const formatearFecha = (fecha) => {
        return new Date(fecha).toLocaleDateString('es-ES', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
    };

    // Obtener noticias destacadas
    const noticiasDestacadas = noticiasData.filter(n => n.destacado).slice(0, 3);

    return (
        <section className="noticias-novedades-section">
            {/* Fondo decorativo */}
            <div className="noticias-background">
                <div className="noticias-shape noticias-shape-1"></div>
                <div className="noticias-shape noticias-shape-2"></div>
                <div className="noticias-pattern"></div>
            </div>

            <Container className="noticias-container py-4">
                {/* Header */}
                <div className="noticias-header text-center">
                    <div className="noticias-badge">
                        <TrendingUp size={20} />
                        <span>Últimas Videos Informativos</span>
                    </div>
                    <h1 className="noticias-title">
                        Videos  <span className="text-highlight-noticias">Informativos</span>
                    </h1>
                    <p className="noticias-subtitle">
                        Mantente informado sobre los últimos lanzamientos, programas y noticias de Salcedo Importaciones SRL
                    </p>
                    <div className="title-divider-noticias"></div>
                </div>
                {/* Noticias destacadas (carousel simple) */}
                {noticiasDestacadas.length > 0 && (
                    <div className="noticias-destacadas">
                        <h2 className="noticias-destacadas-title">Destacadas</h2>
                        <Row className="g-3">
                            {noticiasDestacadas.map((noticia, index) => (
                                <Col lg={4} key={noticia.id}>
                                    <div
                                        className="noticia-destacada"
                                        onClick={() => handleNoticiaClick(noticia)}
                                        style={{ animationDelay: `${index * 0.1}s` }}
                                    >
                                        <div className="noticia-destacada-imagen">
                                            <img src={noticia.imagen} alt={noticia.titulo} />
                                            {noticia.video && (
                                                <div className="play-button-destacado">
                                                    <Play size={32} fill="white" />
                                                </div>
                                            )}
                                            <span className="badge-tipo">{noticia.tipo.toUpperCase()}</span>
                                        </div>
                                        <div className="noticia-destacada-info">
                                            <h3>{noticia.titulo}</h3>
                                            <p>{noticia.descripcion}</p>
                                            <div className="noticia-meta-destacada">
                                                <span><Calendar size={14} /> {formatearFecha(noticia.fecha)}</span>
                                                <span><Eye size={14} /> {noticia.vistas}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                )}
                {/* Buscador y filtros */}
                <div className="noticias-controls">
                    {/* Buscador */}
                    <div className="search-box-noticias">
                        <Search size={20} className="search-icon-noticias" />
                        <input
                            type="text"
                            placeholder="Buscar video..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="search-input-noticias"
                        />
                    </div>

                    {/* Filtros de categoría */}
                    <div className="categoria-filters-noticias">
                        {categorias.map(cat => (
                            <button
                                key={cat.id}
                                className={`filtro-btn-noticias ${filtroCategoria === cat.id ? 'active' : ''}`}
                                onClick={() => setFiltroCategoria(cat.id)}
                            >
                                {cat.nombre}
                            </button>
                        ))}
                    </div>
                </div>

                

                {/* Listado de noticias */}
                <div className="noticias-listado">
                    <h2 className="noticias-listado-title">
                        {searchTerm ? `Resultados de búsqueda (${noticiasOrdenadas.length})` : 'Todas las noticias'}
                    </h2>

                    {noticiasOrdenadas.length > 0 ? (
                        <div className="noticias-grid">
                            {noticiasOrdenadas.map((noticia, index) => (
                                <div
                                    key={noticia.id}
                                    className="noticia-card"
                                    style={{ animationDelay: `${index * 0.05}s` }}
                                >
                                    {/* Imagen */}
                                    <div
                                        className="noticia-card-imagen"
                                        onClick={() => handleNoticiaClick(noticia)}
                                    >
                                        <img src={noticia.imagen} alt={noticia.titulo} />

                                        {/* Play button si tiene video */}
                                        {noticia.video && (
                                            <div className="play-button-overlay">
                                                <div className="play-btn-grande">
                                                    <Play size={40} fill="white" />
                                                </div>
                                                <span className="duracion-video">{noticia.video.duracion}</span>
                                            </div>
                                        )}

                                        {/* Badge categoría */}
                                        <span className={`categoria-badge categoria-${noticia.categoria}`}>
                                            {noticia.categoria}
                                        </span>
                                    </div>

                                    {/* Contenido */}
                                    <div className="noticia-card-content">
                                        <div className="noticia-meta">
                                            <span className="meta-item">
                                                <Calendar size={14} />
                                                {formatearFecha(noticia.fecha)}
                                            </span>
                                            <span className="meta-item">
                                                <User size={14} />
                                                {noticia.autor}
                                            </span>
                                            <span className="meta-item">
                                                <Eye size={14} />
                                                {noticia.vistas}
                                            </span>
                                        </div>

                                        <h3
                                            className="noticia-card-titulo"
                                            onClick={() => handleNoticiaClick(noticia)}
                                        >
                                            {noticia.titulo}
                                        </h3>

                                        <p className="noticia-card-descripcion">
                                            {noticia.descripcion}
                                        </p>

                                        {/* Footer */}
                                        <div className="noticia-card-footer">
                                            <button
                                                className={`btn-noticia-accion ${favoritos.includes(noticia.id) ? 'active' : ''}`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleFavorito(noticia.id);
                                                }}
                                                title="Agregar a favoritos"
                                            >
                                                <Heart size={18} />
                                            </button>

                                            <button
                                                className="btn-noticia-leer-mas"
                                                onClick={() => handleNoticiaClick(noticia)}
                                            >
                                                Leer más
                                                <ChevronRight size={18} />
                                            </button>

                                            <button
                                                className="btn-noticia-accion"
                                                title="Compartir"
                                            >
                                                <Share2 size={18} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="no-noticias">
                            <AlertCircle size={64} />
                            <h3>No se encontraron noticias</h3>
                            <p>Intenta con otros términos de búsqueda o categorías</p>
                        </div>
                    )}
                </div>
            </Container>

            {/* Modal de noticia completa */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="xl"
                className="noticias-modal"
                centered
            >
                {selectedNoticia && (
                    <>
                        <Modal.Header className="noticias-modal-header">
                            <div className="modal-noticia-header-content">
                                <span className={`categoria-badge categoria-${selectedNoticia.categoria}`}>
                                    {selectedNoticia.categoria}
                                </span>
                                <h2>{selectedNoticia.titulo}</h2>
                            </div>
                            <button
                                className="btn-close-noticias"
                                onClick={() => setShowModal(false)}
                            >
                                <X size={24} />
                            </button>
                        </Modal.Header>

                        <Modal.Body className="noticias-modal-body">
                            <Row className="g-4">
                                {/* Video o imagen principal */}
                                <Col lg={7}>
                                    <div className="noticia-multimedia">
                                        {selectedNoticia.video && selectedNoticia.video.archivo ?(
                                            <div className="video-container-noticia">
                                                <video
                                                    width="100%"
                                                    height="auto"
                                                    controls
                                                    autoPlay
                                                    className="video-player-noticia"
                                                >
                                                    <source
                                                        src={selectedNoticia.video.archivo}
                                                        type="video/mp4"
                                                    />
                                                    Tu navegador no soporta videos HTML5
                                                </video>
                                                <p className="video-titulo-noticia">
                                                    {selectedNoticia.video.titulo}
                                                </p>
                                            </div>
                                        ) : (
                                            <img
                                                src={selectedNoticia.imagen}
                                                alt={selectedNoticia.titulo}
                                                className="imagen-modal-noticia"
                                            />
                                        )}
                                    </div>
                                </Col>

                                {/* Información */}
                                <Col lg={5}>
                                    <div className="noticia-info-modal">
                                        {/* Metadata */}
                                        <div className="noticia-metadata-modal">
                                            <div className="metadata-item">
                                                <Calendar size={18} />
                                                <div>
                                                    <p className="label">Fecha</p>
                                                    <p className="valor">{formatearFecha(selectedNoticia.fecha)}</p>
                                                </div>
                                            </div>
                                            {/* <div className="metadata-item">
                                                <User size={18} />
                                                <div>
                                                    <p className="label">Autor</p>
                                                    <p className="valor">{selectedNoticia.autor}</p>
                                                </div>
                                            </div>
                                            <div className="metadata-item">
                                                <Eye size={18} />
                                                <div>
                                                    <p className="label">Vistas</p>
                                                    <p className="valor">{selectedNoticia.vistas}</p>
                                                </div>
                                            </div> */}
                                        </div>

                                        {/* Descripción */}
                                        {/* <div className="noticia-descripcion-modal">
                                            <h3>Descripción</h3>
                                            <p>{selectedNoticia.descripcion}</p>
                                        </div> */}

                                        {/* Contenido */}
                                        {/* <div className="noticia-contenido-modal">
                                            <h3>Detalles</h3>
                                            <p>{selectedNoticia.contenido}</p>
                                        </div> */}

                                        {/* Características */}
                                        {selectedNoticia.caracteristicas.length > 0 && (
                                            <div className="noticia-caracteristicas-modal">
                                                <h3>Características</h3>
                                                {selectedNoticia.caracteristicas.map((caract, idx) => (
                                                    <div key={idx} className="caract-item-noticia">
                                                        <Zap size={16} />
                                                        <span>{caract}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {/* Acciones */}
                                        {/* <div className="noticia-acciones-modal">
                                            <button
                                                className={`btn-noticia-favorito-modal ${favoritos.includes(selectedNoticia.id) ? 'active' : ''}`}
                                                onClick={() => toggleFavorito(selectedNoticia.id)}
                                            >
                                                <Heart size={20} />
                                                {favoritos.includes(selectedNoticia.id) ? 'Agregado' : 'Favorito'}
                                            </button>
                                            <button className="btn-noticia-compartir-modal">
                                                <Share2 size={20} />
                                                Compartir
                                            </button>
                                        </div> */}
                                    </div>
                                </Col>
                            </Row>
                        </Modal.Body>
                    </>
                )}
            </Modal>
        </section>
    );
}

export default VideosNovedades;